module.exports = __webpack_public_path__ + "img/ic-white-o-que-visitar.ee98b7f7.svg";